import React, { useState, useEffect } from "react"
import loadable from '@loadable/component'
import { MEDIUM } from "../util/breakpoints"
import DotList from "../molecules/DotList"
import Image from "../atoms/Image"
import { Mobile, Desktop } from "../util/breakpoints"
import useMediaQuery from '../util/useMediaQuery'

import "react-multi-carousel/lib/styles.css"
import "react-responsive-carousel/lib/styles/carousel.min.css"

const MultiCarousel = loadable(() => import( 'react-multi-carousel' ))
const Carousel = loadable(() => import( 'react-responsive-carousel' ), { resolveComponent: (components) => components.Carousel} )

const siblingVisibilityPx = 16

export default ({ images = [] }) => {
  if(!images.length)
    return null

  const [additionalTransform, setAdditionalTransform] = useState(0)
  const isDesktop = useMediaQuery({ minWidth: MEDIUM })

  // Compensate for the margin-right on each item - this makes the whole carousel wider
  const additionalOffset = -5 * (images.length - 1)

  return (
    <section
      className={ "u-section-spacing" }>
      <Mobile>
        <div className="o-image-row">
          <div className="o-carousel">
            <Carousel
              showThumbs={ false }
              centerMode={ true }
              centerSlidePercentage={ 92.75 }
              showArrows={ false }
              showStatus={ false }
              renderIndicator={(onClickHandler, isSelected, index, label) => {
                return (
                  <li>
                    <button
                      className={ "m-dot-list__item" + ( isSelected ? " m-dot-list__item--active" : "" ) }
                      aria-label={"Move carousel to " + index }
                      onClick={ () => onClickHandler() }
                    />
                  </li>
                )
              }}
            >
              { images.map((image, index) =>
                <div className="o-image-row__item u-object-fit" key={ index }>
                  <Image className="u-object-fit__media" image={ image }/>
                </div>
              ) }
            </Carousel>
          </div>
        </div>
      </Mobile>
      <Desktop>
        <div className="o-image-row">
          <MultiCarousel
            containerClass="o-carousel"
            itemClass="o-image-row__item o-carousel__item"
            dotListClass="o-image-row__dot-list m-dot-list"
            sliderClass="o-image-row__slider"
            showDots={ true }
            customDot={ <DotList/> }
            arrows={ false }
            draggable={ false }
            swipeable
            additionalTransfrom={ isDesktop ? 0 : additionalTransform }
            partialVisible
            responsive={{
              desktop: {
                breakpoint: { max: 3000, min: MEDIUM },
                items: 3,
              },
              mobile: {
                breakpoint: { max: MEDIUM, min: 0 },
                items: 1,
                partialVisibilityGutter: siblingVisibilityPx * 2
              }
            }}
            beforeChange={ (nextPage, { currentSlide }) => {
              if (isDesktop) return

              if (nextPage === 0) {
                setAdditionalTransform(0)
              } else if (currentSlide === 0) {
                setAdditionalTransform(siblingVisibilityPx + additionalOffset)
              }
            }}
          >
            { images.map((image, index) =>
              <div className="o-image-row__item u-object-fit" key={ index }>
                <Image className="u-object-fit__media" image={ image }/>
              </div>
            ) }
          </MultiCarousel>
        </div>
      </Desktop>
    </section>
  )
}
